module.exports = __webpack_public_path__ + "static/img/图层 536.97df8764.png";